import React from 'react';
import { aboutUs, reviews } from '../../helpers/routes';

export const whatWeDoCopy = (localized: (url: string) => string) => ({
  link: (
    <a href={localized(aboutUs)} style={{ fontSize: '15px' }}>
      about us
    </a>
  ),
  text: (
    <>
      We connect savvy luxury shoppers with brand new, in-season fashion and luxury products at a consistent{' '}
      <span style={{ color: '#F25C5E', fontFamily: 'Avenir', fontSize: '15px', fontWeight: 300 }}>
        savings of up to 40%
      </span>
      . Through our network of Italian partner boutiques, orders are delivered by global express mail in 2-4 business
      days. For those in the know, italist just does it better. #italistdoesitbetter
    </>
  ),
  title: 'What we do',
});

export const reviewsCopy = (localized: (url: string) => string) => ({
  link: (
    <a href={localized(reviews)} style={{ fontSize: '15px' }}>
      reviews
    </a>
  ),
  text: (
    <>
      I received timely updates on my order and shipping from the minute I had confirmation of my order. My package
      arrived quickly. Merchandise was well presented and in pristine condition. Bravo! I will definitely be ordering
      from italist again!” <br />
      -Alice M.
    </>
  ),
  title: 'Reviews',
});
